import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Breadcrumb, IconKeys } from "dash-ui";
import { useLocation, useNavigate, matchPath } from "react-router-dom";

import { RoutesPath } from "flow-components/routes/routes";

function BreadcrumbNavigation() {
  const navigate = useNavigate();
  let location = useLocation();
  const { pathname } = location;
  const { t } = useTranslation("common", { keyPrefix: "labels" });
  const items = useMemo(() => {
    const propertiesPreviewMatch = matchPath(
      RoutesPath.PropertyPreview,
      pathname
    );
    const portfolioDetailsMatch = matchPath(
      RoutesPath.PortfolioDetails,
      pathname
    );
    const isPropertiesSearchPage = pathname === RoutesPath.PropertiesSearch;
    const isPropertiesPage =
      pathname.includes(RoutesPath.Properties) && !isPropertiesSearchPage;

    const propertiesBreadcrumb = {
      label: t`properties`,
      path: RoutesPath.Properties,
      icon: "home",
    };

    const searchBreadcrumb = {
      label: t`search`,
      path: RoutesPath.PropertiesSearch,
    };

    return [
      pathname.includes(RoutesPath.Dashboard) && {
        label: t`dashboard`,
        path: RoutesPath.Dashboard,
        icon: "home",
      },
      (isPropertiesSearchPage || isPropertiesPage) && propertiesBreadcrumb,
      isPropertiesSearchPage && searchBreadcrumb,
      propertiesPreviewMatch && {
        label: t`propertyPreview`,
        path: propertiesPreviewMatch?.pathname,
      },
      pathname.includes(RoutesPath.Portfolios) && {
        label: t`portfolios`,
        path: RoutesPath.Portfolios,
        icon: "home",
      },
      portfolioDetailsMatch && {
        label: t`portfolioDetails`,
        path: RoutesPath.PortfolioDetails,
        icon: "home",
      },
      pathname.includes(RoutesPath.Watchlist) && {
        label: t`watchlist`,
        path: RoutesPath.Watchlist,
        icon: "favorite",
      },
    ].filter(Boolean) as { icon?: IconKeys; label: string; path: string }[];
  }, [pathname, t]);

  return (
    <Breadcrumb
      onNavigate={(route) => {
        navigate(route);
      }}
      items={items}
    />
  );
}

export default BreadcrumbNavigation;
